module.exports = __webpack_public_path__ + "create/static/media/cover-profile.72eae866.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/CreateExperience/Steps/BioProfile/cover-profile.jpg
// module id = 454
// module chunks = 37